import React, { useState } from 'react';
import Image from '../../../components/AppImage';

const CaseStudies = () => {
  const [activeCase, setActiveCase] = useState(0);

  const caseStudies = [
  {
    id: 1,
    company: "AutoExcellence Côte d\'Ivoire",
    industry: "Concessionnaire Automobile",
    challenge: "Optimisation de la maintenance et réduction des coûts opérationnels",
    solution: "Implémentation d\'un système IA de maintenance prédictive et gestion intelligente des stocks",
    results: [
    { metric: "Réduction des pannes", value: "72%", icon: "⚡" },
    { metric: "Économies annuelles", value: "€180K", icon: "💰" },
    { metric: "Satisfaction client", value: "+85%", icon: "😊" },
    { metric: "Temps d\'arrêt", value: "-65%", icon: "⏱️" }],

    testimonial: {
      quote: "L\'IA a révolutionné notre approche de la maintenance. Nous anticipons maintenant les problèmes avant qu\'ils n\'impactent nos clients. C\'est un game-changer pour notre business.",
      author: "Marie Traoré",
      position: "Directrice Générale",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c0007e95-1763295050768.png",
      alt: "Portrait professionnel de Marie Traoré, Directrice Générale d'AutoExcellence Côte d'Ivoire, souriante en tailleur professionnel"
    },
    timeline: "8 mois",
    investment: "€45K",
    roi: "340%"
  },
  {
    id: 2,
    company: "MegaMotors Ghana",
    industry: "Importateur & Distributeur",
    challenge: "Personnalisation de l\'expérience client et augmentation des ventes",
    solution: "Système IA de recommandation personnalisée et chatbot intelligent multilingue",
    results: [
    { metric: "Augmentation des ventes", value: "+125%", icon: "📈" },
    { metric: "Taux de conversion", value: "68%", icon: "🎯" },
    { metric: "Temps de réponse", value: "-90%", icon: "⚡" },
    { metric: "Langues supportées", value: "5", icon: "🌍" }],

    testimonial: {
      quote: "Notre chatbot IA comprend parfaitement nos clients locaux. Les ventes ont explosé et nos équipes peuvent se concentrer sur les tâches à haute valeur ajoutée.",
      author: "Kwame Asante",
      position: "Directeur Commercial",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_175d391bd-1763296057973.png",
      alt: "Portrait professionnel de Kwame Asante, Directeur Commercial de MegaMotors Ghana, en costume et souriant"
    },
    timeline: "6 mois",
    investment: "€32K",
    roi: "285%"
  },
  {
    id: 3,
    company: "FleetMaster Sénégal",
    industry: "Gestion de Flotte",
    challenge: "Optimisation des itinéraires et réduction de la consommation carburant",
    solution: "IA d\'optimisation logistique avec analyse prédictive du trafic et maintenance préventive",
    results: [
    { metric: "Économie carburant", value: "42%", icon: "⛽" },
    { metric: "Optimisation routes", value: "+55%", icon: "🛣️" },
    { metric: "Réduction accidents", value: "-78%", icon: "🛡️" },
    { metric: "Productivité", value: "+90%", icon: "📊" }],

    testimonial: {
      quote: "L'IA a transformé notre gestion de flotte. Nos chauffeurs sont plus sûrs, nos coûts ont chuté et nos clients sont ravis de la ponctualité améliorée.",
      author: "Fatou Diop",
      position: "CEO & Fondatrice",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ec250f60-1763294449646.png",
      alt: "Portrait professionnel de Fatou Diop, CEO et Fondatrice de FleetMaster Sénégal, souriante en veste d'affaires"
    },
    timeline: "10 mois",
    investment: "€65K",
    roi: "420%"
  }];


  return (
    <section id="case-studies" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-green-100 text-green-800 text-sm font-medium mb-4">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
            Succès Clients
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Cas d'Études : L'IA en Action
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Découvrez comment nos clients africains ont transformé leur business automobile avec nos solutions IA sur-mesure
          </p>
        </div>

        {/* Case Study Navigation */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {caseStudies?.map((caseStudy, index) =>
          <button
            key={caseStudy?.id}
            onClick={() => setActiveCase(index)}
            className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
            activeCase === index ?
            'bg-green-600 text-white shadow-lg' :
            'bg-white text-gray-700 hover:bg-green-50 hover:text-green-600 border border-gray-200'}`
            }>

              {caseStudy?.company}
            </button>
          )}
        </div>

        {/* Active Case Study */}
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
          {/* Case Header */}
          <div className="bg-gradient-to-r from-green-600 to-blue-600 p-6 text-white">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
              <div>
                <h3 className="text-2xl font-bold mb-2">{caseStudies?.[activeCase]?.company}</h3>
                <p className="text-green-100 mb-2">{caseStudies?.[activeCase]?.industry}</p>
                <p className="text-green-200 text-sm">{caseStudies?.[activeCase]?.challenge}</p>
              </div>
              <div className="mt-4 md:mt-0 flex flex-col space-y-2 text-right">
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-green-200">Timeline:</span>
                  <span className="font-bold">{caseStudies?.[activeCase]?.timeline}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-green-200">ROI:</span>
                  <span className="font-bold">{caseStudies?.[activeCase]?.roi}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Case Content */}
          <div className="p-6">
            {/* Solution Description */}
            <div className="mb-8">
              <h4 className="text-lg font-semibold text-gray-900 mb-3">Solution Implémentée</h4>
              <p className="text-gray-700 leading-relaxed bg-blue-50 p-4 rounded-lg border border-blue-200">
                {caseStudies?.[activeCase]?.solution}
              </p>
            </div>

            {/* Results Metrics */}
            <div className="mb-8">
              <h4 className="text-lg font-semibold text-gray-900 mb-6">Résultats Obtenus</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {caseStudies?.[activeCase]?.results?.map((result, index) =>
                <div key={index} className="text-center bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                    <div className="text-3xl mb-3">{result?.icon}</div>
                    <div className="text-2xl font-bold text-green-600 mb-2">{result?.value}</div>
                    <div className="text-gray-700 text-sm font-medium">{result?.metric}</div>
                  </div>
                )}
              </div>
            </div>

            {/* Testimonial */}
            <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-2xl p-8 border border-purple-200">
              <div className="flex flex-col md:flex-row items-start space-y-6 md:space-y-0 md:space-x-6">
                <div className="flex-shrink-0">
                  <Image
                    src={caseStudies?.[activeCase]?.testimonial?.image}
                    alt={caseStudies?.[activeCase]?.testimonial?.alt}
                    className="w-20 h-20 rounded-full object-cover" />

                </div>
                <div className="flex-1">
                  <div className="mb-4">
                    <svg className="w-8 h-8 text-purple-400 mb-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                    </svg>
                    <p className="text-gray-700 italic text-lg leading-relaxed">
                      "{caseStudies?.[activeCase]?.testimonial?.quote}"
                    </p>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{caseStudies?.[activeCase]?.testimonial?.author}</div>
                    <div className="text-purple-600 font-medium">{caseStudies?.[activeCase]?.testimonial?.position}</div>
                    <div className="text-gray-600 text-sm">{caseStudies?.[activeCase]?.company}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Investment ROI */}
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-purple-50 rounded-xl p-6 border border-purple-200">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-gray-900">Investissement Initial</div>
                    <div className="text-2xl font-bold text-purple-600">{caseStudies?.[activeCase]?.investment}</div>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-gray-900">Retour sur Investissement</div>
                    <div className="text-2xl font-bold text-green-600">{caseStudies?.[activeCase]?.roi}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-green-600 to-blue-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">
              Votre Success Story Commence Maintenant
            </h3>
            <p className="text-green-100 mb-6 max-w-2xl mx-auto">
              Rejoignez ces leaders africains qui ont transformé leur business avec l'IA. 
              Découvrez comment nous pouvons créer votre propre cas de succès.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="px-8 py-3 bg-white text-green-600 font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300">
                Étude de Faisabilité Gratuite
              </button>
              <button className="px-8 py-3 bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold rounded-lg hover:bg-white/30 transition-all duration-300">
                Télécharger Tous les Cas
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default CaseStudies;